import React, { useState } from 'react';
import { Hero } from './landing/Hero';

// Import section components
import { FAQ } from './landing/FAQ';
import { Header } from './landing/Header';
import { CTA } from './landing/CTA';
import { Footer as NewFooter } from './landing/Footer';
import { Features } from './landing/Features';
import { Process } from './landing/Process';
import { Services } from './landing/Services';
import { BudgetModal } from './landing/BudgetModal';
import { I18nProvider } from './i18n/I18nProvider';
import { trackEvent } from './utils/analytics';

// Lazy loaded components
// Removido SimpleContactForm em favor do BudgetModal

function App() {
  const [showForm, setShowForm] = useState(false);
  
  const handleSimulateClick = () => {
    setShowForm(true);
    trackEvent('modal_open', { modal: 'budget' });
  };
  
  const handleCloseForm = () => {
    setShowForm(false);
  };
  
  
  
  return (
    <I18nProvider>
      <div className="min-h-screen bg-white">
        <Header onContactClick={handleSimulateClick} />
        <main>
          <section id="home">
            <Hero onContactClick={handleSimulateClick} />
          </section>
          
          {showForm && (
            <BudgetModal isOpen={showForm} onClose={handleCloseForm} />
          )}
          
          <Features />
          <Process />
          <Services />

          {/* How It Works Section removida */}
          {/* About/Mission Section removida */}
          
          {/* CTA Section */}
          <CTA onContactClick={handleSimulateClick} />
          
          {/* FAQ Section */}
          <FAQ />
        </main>
        
        {/* Footer - Contact */}
        <section id="contact">
          <NewFooter />
        </section>
      </div>
    </I18nProvider>
  );
}

export default App;
